// frontend/src/notifications/usePresence.js
import { useEffect, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import axios from 'axios'

const API = process.env.REACT_APP_API_BASE_URL
const PING_INTERVAL_MS = 30_000  // 30s

/**
 * usePresence — pings backend with current route + case_id.
 * Backend uses this for awareness-routing notifications.
 */
export function usePresence() {
  const loc = useLocation()
  const params = useParams()
  const lastPingRef = useRef(null)

  useEffect(() => {
    const route = loc.pathname
    const domain = route.split('/').filter(Boolean)[0] || null
    // case_id is meaningful only on RMA routes (e.g. /rma/42). On other routes
    // the numeric path segment is a SKU or product/vendor ID — sending it as
    // case_id was the root cause of the 2026-05-06 INTEGER-overflow incident:
    // 12-digit SKU > 2^31 max for user_presence.current_case_id (INTEGER).
    let caseId = null
    if (domain === 'rma') {
      const numericSeg = route.match(/\/(\d+)(?:\/|$)/)
      caseId = numericSeg ? parseInt(numericSeg[1], 10) : (params.id ? parseInt(params.id, 10) : null)
    }

    const send = () => {
      axios.post(`${API}/api/notify/presence`, {
        current_route: route,
        current_domain: domain,
        current_case_id: caseId,
      }).catch(() => {})
    }

    send()
    lastPingRef.current = setInterval(send, PING_INTERVAL_MS)

    return () => clearInterval(lastPingRef.current)
  }, [loc.pathname, params.id])
}
